import experiencesEn from './experiences.en';

export default experiencesEn;
